/*
 * File: ui-submit-ignore.ts
 * File Created: 2024-02-19 08:41:42
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 03:10:16
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

// @uiSubmitIgnore - Ignore / Remove the value on submit.

@UITag.set()
export class uiSubmitIgnore extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    /// set prop sortable: true / false
    parse(input: IUITagInput): IUITagResult {
        /// default: true
        /// rule: true / false
        const rule = Boolean(this.parseRule(input) ?? true);

        return {
            specials: {
                submitIgnore: rule,
            },
        };
    }
}
